import React from "react";
import { Navigate } from "react-router-dom";

const PublicRoute = ({ element: Component }) => {
  const user = JSON.parse(localStorage.getItem("user"));
  return user ? <Navigate to="/institutions" replace /> : <Component />;
};

export default PublicRoute;
